<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <div class="container">
    <h2>{{ $t("auth.signInError.title") }}</h2>
    <p>{{ $t("auth.signInError.description") }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'signin-error-view',
};
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 20px;
}
</style>
